import { PROFILE_IMAGE } from "../actionType";

export const setProfileImage = profileImage => dispatch => {
  dispatch({
    type: PROFILE_IMAGE,
    profileImage,
  });
};
